import { forwardRef } from "react";
import classNames from "classnames";
import { Menu } from "antd";
import type { GetRef, MenuProps } from "antd";
import styles from "./styles.module.scss";

type MenuRef = GetRef<typeof Menu>;

export const AppMenu = forwardRef<MenuRef, MenuProps>(({ className, ...props }, ref) => {
  return <Menu ref={ref} className={classNames(styles.comp, className)} {...props} />;
});
